export default __webpack_public_path__ + "static/commercial-145a2440b3922c499a3ba0a5f1935e6e.png";